module.exports = __webpack_public_path__ + "ed15771abad9f67abbf058e3551e3a3c.svg";